import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  text?: string;
}

export const ClosedDayIndicator = ({ text }: Props) => {
  const { t } = useTranslation('schedule');
  return (
    <div css={containerStyle}>
      <Icon name='moon-small' />
      <Text>{text || t('Closed')}</Text>
    </div>
  );
};

const containerStyle = css({
  background: theme.colors.neutral10,
  width: '100%',
  maxWidth: 345,
  height: 40,
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(1),
  gap: theme.spacing(1),
  opacity: 0.25,
  '@container (max-width: 700px)': {
    maxWidth: 255,
  },
});
